import CapitalTable from "./table";

const Owners = () => {
  return (
      <CapitalTable />
  );
};

export default Owners;
